import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getInvoiceDetail({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query ($id: String) {
        invoiceDetail(id: $id) {
          invoice_number
          generation_date
          expiration_date
          logistic_provider
          total_nf_document
          total_value
          invoice_infos {
            nf_document
            nf_document_serie
            document
            document_number
            nf_document_value
            freight_value
            taxe_value_icms
          }
        }
      }
    `, params)
      .then(({ data }) => {
        const { invoiceDetail = {} } = data || {};
        commit('setInvoiceDetail', invoiceDetail);
        commit('toggleLoading', false);
      })
      .catch(() =>
        commit('toggleLoading', false),
      );
  },

  exportToExcel({ commit }, params) {
    commit('toggleLoadingExports', true);

    return GraphQlClient.query(`
    query($id: String) {
      exportInvoicesDetail(id: $id) {
        ok
      }
    }
    `, params)
      .then(() => commit('toggleLoadingExports', false))
      .catch(() => commit('toggleLoadingExports', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-detail/store/actions.js